// src/pages/chat/ChatSettingsPage.tsx
// Redirects to the unified edit page

import { Navigate, useParams } from 'react-router-dom';

export const ChatSettingsPage = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/chats/${id}/edit`} replace />;
};

export default ChatSettingsPage;
